export default __webpack_public_path__ + "static/media/arrow.df83b09f.svg";